// extracted by mini-css-extract-plugin
export default {"icon":"ButtonIcon_icon__pN9HX"};